// extracted by mini-css-extract-plugin
module.exports = {"heart":"index-module--heart--3YNzy","tippingContainer":"index-module--tipping-container--dcot8"};